import React, { useEffect, useState } from "react";
import { Button, ControlLabel, FormGroup, Well } from "react-bootstrap";
import { clone } from "lodash";
import { DEFAULT_COLOR, COLOR, TITLE_EN, TITLE_RU } from "../constants";
import { initialTagModel } from "../models";
import FormControlLanguage from "../../../UI/FormControlLanguage";

const TagUpdateBlock = (
    {
        editableTag,
        onSave,
        onUpdate,
        onClose,
    }
) => {
    const [model, setModel] = useState(null);
    const [hasError, setHasError] = useState(false);

    useEffect(() => {
        setModel(editableTag ?? clone(initialTagModel));
    }, []);

    const handleChangeModel = (key, value) => {
        setHasError(false);

        setModel((prevState) => {
            return {
                ...prevState,
                [key]: value,
            }
        });
    };

    const handleSaveTag = () => {
        if (!model?.titleRu) {
            setHasError(true);

            return;
        }

        if (!editableTag) {
            onSave(model);

            return;
        }

        onUpdate(model);
        onClose();
    };

    return (
        <Well>
            <FormGroup>
                <ControlLabel>Название тега</ControlLabel>
                <FormControlLanguage
                    type="text"
                    maxLength={50}
                    values={{
                        ru: model?.titleRu ?? '',
                        en: model?.titleEn ?? '',
                    }}
                    onChange={{
                        ru: (e) => handleChangeModel(TITLE_RU, e.target.value),
                        en: (e) => handleChangeModel(TITLE_EN, e.target.value),
                    }}
                />
                <p style={{color: hasError ? 'red' : ''}}>
                    <i>
                        {
                            hasError
                            ? 'Введите название тега'
                            : 'Максимальное количество символов - 50'
                        }
                    </i>
                </p>
            </FormGroup>
            <FormGroup style={{display: 'flex', alignItems: 'center'}}>
                <input
                    type="color"
                    value={model?.color ?? DEFAULT_COLOR}
                    onChange={(e) => handleChangeModel(COLOR, e.target.value)}
                />
                <span style={{color: model?.color}}>&nbsp; Цвет тега</span>
            </FormGroup>
            <Button onClick={handleSaveTag}>
                {editableTag ? 'Сохранить' : 'Добавить в список'}
            </Button>
            <Button
                style={{marginLeft: '12px'}}
                onClick={onClose}
            >
                Отмена
            </Button>
        </Well>
    );
};

export default TagUpdateBlock;
